import SubHeader from "app/styles/SubHeader";
import Button from "./Button";

interface Props {
  error: any;
  resetError: () => void;
}
export default function ErrorWidget(props: Props) {
  const { resetError } = props;

  return (
    <div tw="w-full h-full p-5">
      <div tw="h-full flex flex-col justify-center items-center gap-4 w-full max-w-[480px] mx-auto">
        <SubHeader big>Oops! Something went wrong</SubHeader>

        <Button
          variant="secondary"
          text="Click here to reset!"
          onClick={resetError}
        />
      </div>
    </div>
  );
}
